import { render, staticRenderFns } from "./_product.vue?vue&type=template&id=ad4958e4"
import script from "./_product.vue?vue&type=script&lang=js"
export * from "./_product.vue?vue&type=script&lang=js"
import style0 from "./_product.vue?vue&type=style&index=0&id=ad4958e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports